<script>
    import {
        API_URL,
        CASH_ON_DELIVERY_PRICE,
    } from "../../../env";

    window.scrollTo(0, 0);

    import {order, shoppingCart, showDialogLogin, userData} from "../../js/stores";
    import {push} from "svelte-spa-router";
    import {onMount} from "svelte";
    import {toBase64} from "js-base64";
    import OrderHeader from "./OrderHeader.svelte";
    import ContentLoading from '../../placeholders/ContentLoading.svelte';
    import {addAlert} from "../../js/alert";

    if ($shoppingCart.length === 0) push('/suhrn')   // Když je prázdný košík, nelze se na stránku dostat

    let total_price = parseFloat(sessionStorage.getItem('total_price'))
    let transport_method = sessionStorage.getItem('transportMethodInPerson')

    let canSendOrder = true

    let form = {
        form: undefined,
        name: "",
        surname: "",
        email: "",
        phone: "",
        region: "Slovensko",
        street: "",
        town: "",
        postal_code: "",
        hasAnotherBillingAddress: false,
        billing_region: "Slovensko",
        billing_street: "",
        billing_town: "",
        billing_postal_code: "",
        customer_note: "",
        isCompany: false,
        ico: "",
        dic: "",
        company: "",
        ic_dph: "",
        agreement: false,
        bank_transfer: true,
        heureka_unsolicited: false,
        take_back: false,
        change_wheels: false
    };

    let validity = {
        name: false,
        surname: false,
        email: false,
        phone: false,
        street: false,
        town: false,
        postal_code: false,
        billing_street: false,
        billing_town: false,
        billing_postal_code: false,
        ico: false,
        dic: false,
        company: false,
        ic_dph: false,
        payment: false
    }

    /* ACCOUNT ***********************/

    let userAddresses = []
    let isPageLoaded = false
    let isSelectingAddress = true
    let shouldSaveAddress = false

    onMount(async () => {
        if ($userData !== null) {
            const res = await fetch(API_URL + '/users/addresses', {
                method: 'GET',
                credentials: "include",
            })

            isPageLoaded = true

            if (!res.ok) {
                isSelectingAddress = false
                isPageLoaded = true
                return addAlert("danger", "Chyba", "Nepodarilo sa načítať vaše adresy, skúste to prosím neskôr, alebo zadajte adresu manuálne.")
            }

            userAddresses = await res.json()

            if (userAddresses.length === 0) {
                shouldSaveAddress = true
                isSelectingAddress = false
            }
            return
        }

        isSelectingAddress = false
        isPageLoaded = true
    })

    function handleOpenLogin() {
        showDialogLogin.set({show: true, type: "login", data: {redirect: false}})
    }

    async function saveAddress() {
        let body = {
            name: form.name,
            surname: form.surname,
            email: form.email,
            phone: form.phone,
            street: form.street,
            city: form.town,
            zip: form.postal_code,
        }

        body.has_other_billing_address = form.isCompany
        body.is_company = form.isCompany
        if (body.is_company) {
            body.ico = form.ico
            body.company = form.company
            body.dic = (form.dic)? form.dic : null
            body.ic_dph = (form.ic_dph)? form.dic : null
            body.billing_street = form.billing_street
            body.billing_city = form.billing_town
            body.billing_zip = form.billing_postal_code
            body.has_other_billing_address = true;
        }

        await fetch(API_URL + '/users/addresses', {
            method: 'POST',
            credentials: "include",
            headers: {
                "Content-Type" : "application/json"
            },
            body: JSON.stringify(body)
        })
    }

    function handleSelectAddress(index) {
        form.name = userAddresses[index].name
        form.surname = userAddresses[index].surname
        form.email = $userData?.email
        form.phone = userAddresses[index].phone
        form.street = userAddresses[index].street
        form.town = userAddresses[index].city
        form.postal_code = userAddresses[index].zip

        if (userAddresses[index].is_company) {
            form.isCompany = userAddresses[index].is_company
            form.ico = userAddresses[index].ico
            form.dic = userAddresses[index].dic || ""
            form.company = userAddresses[index].company
            form.ic_dph = userAddresses[index].ic_dph  || ""
            form.hasAnotherBillingAddress = form.isCompany
            form.billing_street = userAddresses[index].billing_street
            form.billing_town = userAddresses[index].billing_city
            form.billing_postal_code = userAddresses[index].billing_zip
        }

        isSelectingAddress = false
    }

    /*****************************************/
    async function handleSubmitForm() {
        if (!canSendOrder) return;
        // if (Foxentry.isFormValid(form.form) === false) return;

        canSendOrder = false
        let ret = false

        const phoneRegex = /^((\+(\d){1,3})|(00(\d){1,3})|0)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        validity = {
            name: false,
            surname: false,
            email: false,
            phone: false,
            street: false,
            town: false,
            postal_code: false,
            billing_street: false,
            billing_town: false,
            billing_postal_code: false,
            ico: false,
            dic: false,
            company: false,
            ic_dph: false,
            payment: false
        }

        if (!form.agreement) {
            validity.agreement = false
            addAlert("danger", "Chyba", "Musíte súhlasiť so spracovaním obchodných údajov!");
            return canSendOrder = true//alert('Musíte souhlasit se zpracováním obchodních údajů!')
        }


        if (form.name.length === 0) {
            validity.name = true
            ret = true
        }
        if (form.surname.length === 0) {
            validity.surname = true
            ret = true
        }
        if (!emailRegex.test(form.email)) {
            validity.email = true
            ret = true
        }
        if (!phoneRegex.test(form.phone)) {
            validity.phone = true
            ret = true
        }
        if (form.street.length === 0) {
            validity.street = true
            ret = true
        }
        if (form.town.length === 0) {
            validity.town = true
            ret = true
        }
        if (form.postal_code.length === 0) {
            validity.postal_code = true
            ret = true
        }
        if (typeof form.bank_transfer != "boolean") {
            ret = true
        }

        if (form.isCompany) {
            if (form.ico.length === 0) {
                validity.ico = true
                ret = true
            }
            if (form.company.length === 0) {
                validity.company = true
                ret = true
            }
            if (form.billing_street.length === 0) {
                validity.billing_street = true
                ret = true
            }
            if (form.billing_town.length === 0) {
                validity.billing_town = true
                ret = true
            }
            if (form.billing_postal_code.length === 0) {
                validity.billing_postal_code = true
                ret = true
            }
        }

        if (ret) {
            addAlert("danger", "Chyba", "Vyplňte všetky povinné polia!");
            return canSendOrder = true;
        }

        let body = {
            name: form.name,
            surname: form.surname,
            email: form.email,
            phone: form.phone,
            country: form.region,
            street: form.street,
            city: form.town,
            zip: form.postal_code,
            bank_transfer: form.bank_transfer,
            customer_note: form.customer_note,
            heureka_unsolicited: form.heureka_unsolicited,
            take_back: form.take_back,
            user: null,
            change_wheels: form.change_wheels ? 1 : 0
        }

        body.cart = $shoppingCart.map(item => {
            return {
                id: item.product_id,
                name: item.name,
                count: item.amount,
                price: item.price,
            }
        })

        body.total = total_price;

        if (form.isCompany) {
            body.ico = form.ico
            body.dic = form.dic
            body.company = form.company
            body.ic_dph = form.ic_dph

            if (body.dic === "") {
                body.dic = null
            }
            if (body.ic_dph === "") {
                body.ic_dph = null
            }

            body.billing_country = form.billing_region
            body.billing_street = form.billing_street
            body.billing_city = form.billing_town
            body.billing_zip = form.billing_postal_code
        }

        if ($userData !== null) {
            if (shouldSaveAddress) {
                await saveAddress()
            }

            body.user = $userData.id
        }

        const res = await fetch(API_URL + '/order', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        if (!res.ok || res.status === 500) {
            let resBody = await res.json()
            console.error('Order fetch error!', resBody)
            if (resBody.state === "send_email") {
                addAlert("danger", "Chyba", "Vaša objednávka bola úspešne vytvorená, ale nastala chyba pri odosielaní e-mailu s faktúrou. Pre zaslanie e-mailu nás prosím kontaktujte.");
                order.set({})
                return await handleCompletionRedirect(body.bank_transfer)
            }
            else if (resBody.state === "cart_destroy") {
                addAlert("danger", "Chyba", "Vaša objednávka bola úspešne vytvorená, ale nastala chyba pri vyprázdňovaní košíka. Vaša objednávka nie je nijako ohrozená, len musíte pre ďalší nákup ručne vysypať košík.");
                order.set({})
                return await handleCompletionRedirect(body.bank_transfer)
            }
            else {
                addAlert("danger", "Chyba", "Chyba pri vytváraní objednávky, skúste to prosím znova.");
            }

            canSendOrder = true
            return
        } else {
            let response = await res.json()
            body.order_id = response.order_id
            body.payment_id = response.payment_id
            let orderBase64 = toBase64(JSON.stringify(body))

            shoppingCart.set([])
            order.set(body)
            await handleCompletionRedirect(body.bank_transfer, orderBase64)
        }
    }

    // TODO předávat objednávku v parametrech
    async function handleCompletionRedirect(paygateRedirect, base64="") {
        if (paygateRedirect) {
            // await push(`/dokoncenie/platobna-brana`)
            await push(`/dokoncenie`)
        }
        else {
            await push("/dokoncenie")
        }
    }

    /*****************************************/

    function checkButtonDisabled(form) {
        return (form.agreement === true && form.bank_transfer !== undefined)
    }

</script>

<section class="container">
    {#if !isPageLoaded}
        <ContentLoading/>
    {:else}
        <div class="order">
            <div class="row d-flex justify-content-center">
                <form class="col-lg-10 col-xl-8 col-xxl-6" bind:this={form.form} on:submit|preventDefault>

                    <OrderHeader step={2}/>

                    <div class="order-body">
                        {#if $userData === null}
                            <div class="order-account">
                                <span>UŽ MÁTE PNEUIN ÚČET?</span>
                                <p><a on:click={handleOpenLogin} style="cursor: pointer">Prihláste sa</a>, sledujte status objednávky a ušetrite si čas zadávaním dodacích údajov.</p>
                            </div>
                        {/if}

                        {#if typeof $userData === "object" && isSelectingAddress && userAddresses.length > 0}
                            <!-- TODO TADY ÚČET -->
                            <div class="order-selection">
                                <h3>Vyberte dodacie údaje</h3>
                                <div class="sel-list">
                                    {#each userAddresses as address}
                                        <!--                                        <div class="sel-item">-->
                                        <!--                                            <div class="sel-text">-->
                                        <!--                                                <h4>Dávid Tkáč</h4>-->
                                        <!--                                                <ul>-->
                                        <!--                                                    <li><span>Kostolná 102/54</span></li>-->
                                        <!--                                                    <li><span>044 13, Valaliky</span></li>-->
                                        <!--                                                    <li><span>+421902694884</span></li>-->
                                        <!--                                                </ul>-->
                                        <!--                                            </div>-->
                                        <!--                                            <div class="sel-button">-->
                                        <!--                                                VYBRAŤ<i class="fas fa-fw fa-arrow-right ml-2"></i>-->
                                        <!--                                            </div>-->
                                        <!--                                        </div>-->
                                        <div class="sel-item" on:click={() => { handleSelectAddress(userAddresses.indexOf(address)) }}>
                                            <div class="sel-text">
                                                <!--                                                <h4>Neoloop s.r.o.</h4>-->
                                                <!--                                                <ul class="company">-->
                                                <!--                                                    <li><span>Kostolná 102/54</span></li>-->
                                                <!--                                                    <li><span>044 13, Valaliky</span></li>-->
                                                <!--                                                    <li><span>+421902694884</span></li>-->
                                                <!--                                                    <li>IČ <span>5468784</span></li>-->
                                                <!--                                                    <li>DIČ <span>546878451</span></li>-->
                                                <!--                                                    <li>IČ DPH <span>SK546878451</span></li>-->
                                                <!--                                                </ul>-->
                                                <h4>
                                                    {#if address.is_company}
                                                        {address.company}
                                                    {:else}
                                                        {address.name} {address.surname}
                                                    {/if}
                                                </h4>
                                                <ul class:company={address.is_company}>
                                                    <li><span>{address.street}</span></li>
                                                    <li><span>{address.zip}, {address.city}</span></li>
                                                    <li><span>{address.phone}</span></li>
                                                    {#if address.is_company}
                                                        <li>IČO <span>{address.ico || ""}</span></li>
                                                        <li>DIČ <span>{address.dic || ""}</span></li>
                                                        <li>IČ DPH <span>{address.ic_dph || ""}</span></li>
                                                    {/if}
                                                </ul>
                                            </div>
                                            <div class="sel-button">
                                                VYBRAŤ<i class="fas fa-fw fa-arrow-right ml-2"></i>
                                            </div>
                                        </div>
                                    {/each}
                                </div>
                                <div class="sel-link">
                                    <a on:click={() => { shouldSaveAddress = true; isSelectingAddress = false }} style="cursor:pointer">Chcem vyplniť nové dodacie údaje manuálne</a>
                                </div>
                            </div>
                            <!-- TODO KONEC TADY ÚČET -->
                        {:else}
                            <div class="order-form">
                                <div class="row">
                                    <div class="col-md-6 mb-4">
                                        <div class="input-group">
                                            <label for="formName">Meno</label>
                                            <input class:unfilled={validity.name} id="formName" type="text" bind:value={form.name} placeholder="Meno" maxlength="32">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-4">
                                        <div class="input-group">
                                            <label for="formSurname">Priezvisko</label>
                                            <input class:unfilled={validity.surname} id="formSurname" type="text" bind:value={form.surname} placeholder="Priezvisko" maxlength="32">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-4">
                                        <div class="input-group">
                                            <label for="formEmail">E-mail</label>
                                            <input class:unfilled={validity.email} id="formEmail" type="email" bind:value={form.email} placeholder="E-mail">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-4">
                                        <div class="input-group">
                                            <label for="formEmail">Telefon</label>
                                            <input class:unfilled={validity.phone} id="formTel" type="tel" bind:value={form.phone} placeholder="Telefon">
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mb-4">
                                        <div class="input-group">
                                            <label for="formRegion">Krajina</label>
                                            <input id="formRegion" type="text" bind:value={form.region} disabled>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-4">
                                        <div class="input-group">
                                            <label for="formTown">Mesto / Obec</label>
                                            <input class:unfilled={validity.town} id="formTown" type="text" bind:value={form.town} placeholder="Mesto / Obec">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-4">
                                        <div class="input-group">
                                            <label for="formStreet">Ulica a číslo domu</label>
                                            <input class:unfilled={validity.street} id="formStreet" type="text" bind:value={form.street} placeholder="Ulica a číslo domu" maxlength="64">
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-4">
                                        <div class="input-group">
                                            <label for="formPSC">PSČ</label>
                                            <input class:unfilled={validity.postal_code} id="formPSC" type="text" bind:value={form.postal_code} placeholder="PSČ" maxlength="6">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="input-group">
                                            <label for="textNote">Poznámka</label>
                                            <textarea id="textNote" bind:value={form.customer_note} placeholder="Poznámka k objednávke..." rows="6"></textarea>
                                        </div>
                                    </div>

                                    <!-- Podnikatel -->
                                    <div class="col-lg-12">
                                        <div class="order-check mb-3 mt-3">
                                            <input class="checkbox_animated" id="formIsCompany" type="checkbox" bind:checked={form.isCompany}>
                                            <label for="formIsCompany">Nakupujem ako podnikateľ</label>
                                        </div>
                                    </div>
                                    {#if form.isCompany}
                                        <div class="col-md-6 mb-4">
                                            <div class="input-group">
                                                <label for="formCompany">Spoločnosť</label>
                                                <input class:unfilled={validity.company} id="formCompany" type="text" bind:value={form.company} placeholder="Spoločnosť" maxlength="64">
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-4">
                                            <div class="input-group">
                                                <label for="formICO">IČO</label>
                                                <input class:unfilled={validity.ico} id="formICO" type="text" bind:value={form.ico} placeholder="IČO" maxlength="10">
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-4">
                                            <div class="input-group">
                                                <label for="formDIC">DIČ (voliteľné)</label>
                                                <input class:unfilled={validity.dic} id="formDIC" type="text" bind:value={form.dic} placeholder="DIČ (voliteľné)" maxlength="14">
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-4">
                                            <div class="input-group">
                                                <label for="formICDPH">IČ DPH (voliteľné)</label>
                                                <input class:unfilled={validity.ic_dph} id="formICDPH" type="text" bind:value={form.ic_dph} placeholder="IČ DPH (voliteľné)" maxlength="14">
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-4">
                                            <div class="input-group">
                                                <label for="formBillingTown">Mesto / Obec</label>
                                                <input class:unfilled={validity.billing_town} id="formBillingTown" type="text" bind:value={form.billing_town} placeholder="Mesto / Obec" maxlength="40">
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-4">
                                            <div class="input-group">
                                                <label for="formBillingStreet">Adresa spoločnosti</label>
                                                <input class:unfilled={validity.billing_street} id="formBillingStreet" type="text" bind:value={form.billing_street} placeholder="Adresa spoľočnosti" maxlength="64">
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-4">
                                            <div class="input-group">
                                                <label for="formBillingPSC">PSČ</label>
                                                <input class:unfilled={validity.billing_postal_code} id="formBillingPSC" type="text" bind:value={form.billing_postal_code} placeholder="PSČ" maxlength="6">
                                            </div>
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        {/if}
                    </div>
                    
                    {#if !isSelectingAddress}

                        {#if transport_method === "true"}

                            <!--<div class="order-optional">
                                <h2>Voliteľné služby</h2>
                                <p>Keďže ste zvolili vyzdvihnutie na predajni...</p>
                                <ul>
                                    <li>
                                        <label>
                                            <div class="input-wrapper">
                                                <input class="checkbox_animated" bind:checked={form.change_wheels} type="checkbox">
                                            </div>
                                            <div class="item-wrapper">
                                                <span>Mám záujem o prezutie pneumatík</span>
                                                <p>Ste z <b>okolia Košíc</b> a nechcete sa obťažovať s vybavovaním servisu, ktorý vám prezuje? Urobíme to za vás! Táto služba nie je záväzná a my vás budeme kontaktovať ohľadom dohodnutia termínu.</p>
                                            </div>
                                        </label>
                                    </li>
                                </ul>
                            </div>-->

                        {/if}

                        <div class="order-payment">
                            <h2>Platba</h2>
                            <ul>
                                <li class:focused={form.bank_transfer === false}>
                                    <label>
                                        <input type="radio" bind:group={form.bank_transfer} value={false}>
                                        <i class="fas fa-fw fa-wallet"></i> {(sessionStorage.getItem('transportMethodInPerson') === "true")? 'Platba na mieste' : 'Dobierka'}
                                        <span>{CASH_ON_DELIVERY_PRICE.toFixed(2)}€</span>
                                    </label>

                                </li>
                                <li class:focused={form.bank_transfer === true}>
                                    <label>
                                        <input type="radio" bind:group={form.bank_transfer} value={true} checked={true}>
                                        <i class="fas fa-fw fa-arrow-right-arrow-left"></i>Bankový prevod
                                        <span>Zdarma</span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <div class="order-body">
                            <div class="order-form mt-4">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="order-check mb-3">
                                            <input class:unfilled={validity.agreement === false && !form.agreement} class="checkbox_animated" id="formCheck" type="checkbox" bind:checked={form.agreement}>
                                            <label for="formCheck">Súhlasím so <a target="_blank" href="#/ochrana-osobnych-udajov">spracovaním osobných údajov</a></label>
                                        </div>
                                        <div class="order-check mb-3">
                                            <input class="checkbox_animated" id="formHeureka" type="checkbox" bind:checked={form.heureka_unsolicited}>
                                            <label for="formHeureka">Nesúhlasím so zaslaním dotazníku spokojnosti od portálu Heureka.sk</label>
                                        </div>
                                        <!--<div class="order-check mb-3">
                                            <input id="formTakeBack" type="checkbox" bind:checked={form.take_back}>
                                            <label for="formTakeBack">Bezplatný spätný odber odpadových pneumatík</label>
                                        </div>-->
                                        <div class="order-check">
                                            <label>Odoslaním objednávky súhlasíte s <a target="_blank" href="#/obchodne-podmienky">obchodnými podmienkami</a></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="order-footer">
                            <div class="footer-text">
                                <div class="float-left">
                                    <h2>Celkom:</h2>
                                </div>
                                <div class="float-right">
                                    <h2>{(form.bank_transfer === false)? (((total_price + CASH_ON_DELIVERY_PRICE)*2).toFixed(1)/2).toFixed(2) : total_price.toFixed(2)}€</h2>
                                    <p>s DPH</p>
                                </div>
                            </div>
                            <div class="footer-buttons">
                                <button class="btn btn-slate-50" type="reset" on:click={() => push('/suhrn')}>Späť na súhrn</button>
                                <button class="btn btn-primary" type="submit" on:click|preventDefault={handleSubmitForm}>Objednávka s povinnosťou platby<i class="far fa-fw {(canSendOrder)? 'fa-arrow-right-long' : 'fa-spin fa-spinner-third'} ml-2"></i></button>
                            </div>
                        </div>
                    {/if}
                </form>
            </div>
        </div>
    {/if}
</section>

<style>
    .order-account {
        background-color: var(--color-slate-50);
        padding: 1.8rem;
        border-radius: .75rem;
        margin-bottom: 2rem;
        font-size: 1.1rem;
    }
    .order-account span {
        font-weight: 700;
        color: black;
    }
    .order-account p {
        margin-top: 1rem;
        color: var(--color-slate-600);
    }
    .order-account p a {
        text-decoration: underline;
        transition: color 0.2s linear;
    }
    .order-account p a:hover {
        color: #545454;
    }
    .order-form .order-check {
        font-family: Rubik, sans-serif;
        font-weight: 400;
        color: var(--color-slate-500);
        margin-bottom: 5px;
    }
    .order-form .order-check input {
        margin-right: .5rem;
    }
    .order-form .order-check a {
        color: var(--color-primary);
    }
    .order-selection .sel-link {
        width: 100%;
        text-align: center;
        text-decoration: underline;
        margin: 1.5rem 0 2rem 0;
    }
    .order-selection .sel-link a {
        color: #303030;
        transition: color 0.2s linear;
    }
    .order-selection .sel-link a:hover {
        color: #1A7ABA;
    }
    .order-selection h3 {
        font-family: Rubik, sans-serif;
        font-weight: 700;
        width: 100%;
        border-bottom: 2px solid rgba(0, 0, 0, 0.05);
        padding-bottom: 0.5rem;
        margin-bottom: 1.5rem;
        font-size: 1.3rem;
    }
    .order-selection .sel-list {
        display: flex;
        flex-direction: column;
    }
    .order-selection .sel-list .sel-item {
        border: 1px solid #00000026;
        border-radius: 15px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        padding: 1.8rem 2rem;
        transition: color 0.2s linear, background-color 0.2s linear;
        cursor: pointer;
        margin-bottom: 1rem;
        position: relative;
        overflow: hidden;
    }
    .order-selection .sel-list .sel-item:after {
        content: '';
        height: 8rem;
        width: 8rem;
        position: absolute;
        background: url("/assets/img/icons/pneuin_ikona_cierna.svg") no-repeat;
        background-size: contain;
        top: 2.5rem;
        left: -1rem;
        opacity: .1;
    }
    .order-selection .sel-list .sel-item:hover {
        color: white;
        background-color: var(--color-primary);
    }
    .order-selection .sel-list .sel-item h4 {
        font-size: 1.1rem;
        margin-bottom: 0.7rem;
        font-family: Rubik, sans-serif;
        font-weight: 700;
    }
    .order-selection .sel-list .sel-item ul {
        list-style-type: none;
        padding-left: 0;
        columns: 1;
    }
    .order-selection .sel-list .sel-item ul.company {
        columns: 2;
    }
    .order-selection .sel-list .sel-item ul li {
        line-height: 1.4rem;
        font-weight: 800;
    }
    .order-selection .sel-list .sel-item ul li span {
        font-weight: 400;
    }
    .order-selection .sel-list .sel-item .sel-button {
        font-family: Rubik, sans-serif;
        font-weight: 700;
        display: flex;
        place-items: center;
    }
    .order-selection .sel-list .sel-item .sel-button i {
        font-size: 1.5rem;
        margin-right: 1.5rem;
        transition: margin-right 0.2s linear;
    }
    .order-selection .sel-list .sel-item:hover i {
        margin-right: 1rem;
    }
    .order-optional {
        margin: 1rem 0 .5rem 0;
    }
    .order-optional h2 {
        margin-bottom: .5rem;
    }
    .order-optional p {
        margin-bottom: .75rem;
        color: var(--color-slate-500);
    }
    .order-optional ul {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        list-style-type: none;
        padding-left: 0;
    }
    .order-optional ul li label {
        padding: 2.25rem 1.75rem;
        border-radius: .75rem;
        display: flex;
        flex-direction: row;
        gap: 2rem;
        position: relative;
        background-size: cover;
        background-position: center;
        background-image: url('/assets/img/carousel/carousel-4.webp');
        overflow: hidden;
        user-select: none;
        outline: 2px solid transparent;
        transition: .1s linear;
    }
    .order-optional ul li label:has(input:checked) {
        outline-color: var(--color-secondary);
        box-shadow: 0 0 16px 0 #E6502591;
    }
    .order-optional ul li label:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(264.86deg, rgba(15, 23, 42, 0.5) 0%, rgba(15, 23, 42, 0.95) 100%);
        z-index: 100;
    }
    .order-optional ul li label input {
        accent-color: var(--color-secondary);
    }
    .order-optional ul li label * {
        z-index: 150;
    }
    .order-optional ul li label .input-wrapper {
        height: 5.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .order-optional ul li label .input-wrapper .checkbox_animated:after {
        background: white;
        border-color: white;
    }
    .order-optional ul li label .input-wrapper .checkbox_animated:checked:before {
        border-color: white;
    }
    .order-optional ul li label .input-wrapper .checkbox_animated:checked:after {
        background-color: var(--color-secondary);
        border-color: var(--color-secondary);
    }
    .order-optional ul li label .item-wrapper {
        display: flex;
        flex-direction: column;
    }
    .order-optional ul li label .item-wrapper span {
        font-size: 1.5rem;
        font-weight: 500;
        margin-bottom: 1rem;
        color: var(--color-secondary);
    }
    .order-optional ul li label .item-wrapper p {
        color: rgba(255, 255, 255, .7);
        line-height: 1.4rem;
        margin-bottom: 0;
    }

    .order-payment {
        padding-top: 1.5rem;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .order-payment h2 {
        font-size: 1.3rem;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        color: var(--color-slate-900);
    }
    .order-payment p {
        font-family: Rubik, sans-serif;
        font-weight: 300;
        padding: 1rem 0;
        font-size: 1rem;
        border-bottom: 1px solid var(--color-slate-200);
    }
    .order-payment ul {
        margin-top: .5rem;
        list-style-type: none;
        padding-left: 0;
    }
    .order-payment ul li {
        display: flex;
        border-bottom: 1px solid var(--color-slate-200);
    }
    .order-payment ul li:first-child {
        border-top: 1px solid var(--color-slate-200);
    }
    .order-payment ul li label {
        width: 100%;
        padding: 1rem 0;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: 0.1s linear;
        color: var(--color-slate-500);
    }
    .order-payment ul li.focused label {
        color: var(--color-slate-900);
    }
    .order-payment ul li label input {
        margin-right: 1rem;
        accent-color: var(--color-primary);
    }
    .order-payment ul li label i {
        color: var(--color-slate-900);
        font-size: 1.15rem;
        margin-right: .75rem;
    }
    .order-payment ul li span {
        margin-left: auto;
        font-family: Rubik, sans-serif;
        font-weight: 500;
    }
    .order-footer {
        padding: 1.5rem 0;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .order-footer h2 {
        color: var(--color-slate-900);
        font-family: Rubik, sans-serif;
        font-weight: 500;
    }
    .order-footer p {
        color: var(--color-slate-500);
        font-family: Rubik, sans-serif;
        font-weight: 300;
        text-align: end;
    }
    .order-footer .footer-buttons {
        display: flex;
        flex-flow: row;
        justify-content: end;
        gap: 1rem;
        width: 100%;
        margin-top: 2rem;
    }
    .order-footer .float-left {
        display: flex;
        gap: 0.4rem;
    }
    .order-footer .footer-info i {
        padding-top: 0.3rem;
        font-size: 1.3rem;
    }
    @media (max-width: 575.98px) {
        .order-footer .footer-buttons {
            flex-wrap: wrap;
        }
        .order-footer .footer-buttons button {
            width: 100%;
        }
    }
</style>